import {
  CREATING_ORDER,
  CREATING_SCHEDULE,
  GET_ORDERS_DONE,
  GET_SCHEDULES_DONE,
  GETTING_ORDERS,
  GETTING_SCHEDULES,
  IS_GETTING_DRAFT,
  SET_DEPARTMENT_LIST,
  SET_DRAFT_ORDER,
  SET_SCHEDULE,
  UPDATE_DRAFT_ORDER,
  UPDATE_ORDER_FAIL,
} from './constants';

export default {
  [GET_ORDERS_DONE](state, payload) {
    state.orders = payload;
  },
  [GET_SCHEDULES_DONE](state, payload) {
    state.schedules = payload;
  },
  [CREATING_ORDER](state, creating) {
    state.creatingOrder = creating;
  },
  [CREATING_SCHEDULE](state, creating) {
    state.creatingSchedule = creating;
  },
  [GETTING_ORDERS](state, getting) {
    state.gettingOrders = getting;
  },
  [GETTING_SCHEDULES](state, getting) {
    state.gettingSchedules = getting;
  },
  [IS_GETTING_DRAFT](state, getting) {
    state.isGettingDraft = getting;
  },
  [SET_DEPARTMENT_LIST](state, list) {
    state.departments = list;
  },
  [SET_DRAFT_ORDER](state, order) {
    state.draftOrder = order;
  },
  [SET_SCHEDULE](state, schedule) {
    state.schedule = schedule;
  },
  [UPDATE_DRAFT_ORDER](state, order) {
    state.draftOrder = { ...state.draftOrder, ...order };
  },
  [UPDATE_ORDER_FAIL](state, isFail) {
    state.updateOrderFail = isFail;
  },
};
